const decideDropdownCornerRadius = (isLeft = true) => (isLeft ? { borderTopLeftRadius: 0 } : { borderTopRightRadius: 0 });

export default decideDropdownCornerRadius;
